import * as Sentry from '@sentry/react';

/**
 * The `.catch` for a dispatch whose thunk has already told the user what went
 * wrong.
 *
 * Every async thunk here ends its failure path the same way: show the user a
 * notification, then `rejectWithValue(message)` with a plain string. That
 * rejection needs catching — left alone it reaches the browser as an unhandled
 * rejection and Sentry files an ordinary form rule ("You can't raise a request
 * on behalf of yourself") as an exception — but catching it with an empty
 * function silences the path completely, including the failures nobody has
 * handled.
 *
 * So the string case is dropped and everything else is reported. `unwrapResult`
 * rethrows a `rejectWithValue` payload as-is (the string), while a thunk that
 * threw arrives as a SerializedError and a coding error as an Error — neither
 * is a string, and both are worth knowing about.
 *
 * @param error Whatever the rejected promise carried.
 */
export const reportUnexpectedRejection = (error: unknown): void => {
    if (typeof error === 'string') {
        return;
    }

    Sentry.captureException(error);
};

export default reportUnexpectedRejection;
